import { render } from "./SuccessfulModal.vue?vue&type=template&id=eb4f4c6a&ts=true"
import script from "./SuccessfulModal.vue?vue&type=script&lang=ts"
export * from "./SuccessfulModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__